import { Store } from 'stores/type';
import { Firebase } from './../types';
import FirebaseDatabaseHandler from './handler';

class FirebaseDatabase {
  public handler!: FirebaseDatabaseHandler;

  public async init(firebase: Firebase, store: Store, reinitialize: () => Promise<any>) {
    // tslint:disable-next-line variable-name
    const Handler = await this.load();
    await reinitialize();
    this.handler = new Handler(firebase, store);
  }
  private async load() {
    const [, handler] = await Promise.all([this.loadDatabase(), this.loadHandler()]);
    return handler;
  }
  private loadDatabase() {
    // @ts-ignore
    return import(/* webpackChunkName: "firebase-database" */ 'firebase/database');
  }
  private async loadHandler() {
    const module = await import(/* webpackChunkName: "firebase-database-handler" */ './handler');
    return module.default;
  }

  public destroy() {
    if (this.handler) {
      this.handler.destroy();
    }

    // @ts-ignore
    this.handler = null;
  }
}

export default FirebaseDatabase;
